/* eslint-disable complexity */
import {React, i18n} from 'common'
import {Avatar, CardHeader, Typography, styled} from '@mui/material'

const DanceCardHeader = ({dance}) => {
    const {creators, song, name: danceTitle} = dance || {}
    const {composers, lyricists} = song || {}
    const t18Dance = (text) => i18n.t(`dance.${text}`)

    const {firstName, lastName} = creators?.[0] || {}
    const {hebName: hebNameLyricist, engName: engNameLyricist} =
        lyricists[0] || {}
    const {hebName: hebNameComposer, engName: engNameComposer} =
        composers[0] || {}
    return (
        <>
            <StyledCardHeader
                avatar={<StyledAvatar aria-label="choreograph" src={''} />}
                title={danceTitle || 'Unknown Dance'}
                subheader={
                    firstName && lastName
                        ? `${firstName} ${lastName}`
                        : 'Unknown Creator'
                }
            />
            <Text variant="subtitle2" color="textSecondary">
                {`${t18Dance('lyricists')}: ${
                    hebNameLyricist || engNameLyricist || ''
                }`}
            </Text>
            <Text variant="subtitle2" color="textSecondary">
                {`${t18Dance('composers')}: ${
                    hebNameComposer || engNameComposer || ''
                }`}
            </Text>
        </>
    )
}

export default DanceCardHeader

const StyledCardHeader = styled(CardHeader)`
    background-color: #f4f4f4;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`

const StyledAvatar = styled(Avatar)`
    background-color: #e0e0e0;
`

const Text = styled(Typography)`
    font-size: 0.9rem;
`
